import * as React from 'react'
import { redirect } from 'react-router-dom'

import i18n from 'modules/core/lib/i18n'
import { NavigationRoutesFn, buildRoute } from 'modules/core/lib/react-router'

const RootPage = React.lazy(() => import('modules/expenses/pages/my_expenses/RootPage'))

const RequestCardPage = React.lazy(
  () => import('modules/expenses/pages/my_expenses/RequestCardPage')
)
const MyCardsPage = React.lazy(() => import('modules/expenses/pages/my_expenses/MyCardsPage'))

export const myCardsRoutes: NavigationRoutesFn = (navigation) => {
  return [
    buildRoute({
      path: navigation.myCards.path,
      element: <RootPage />,
      children: [
        {
          index: true,
          handle: {
            meta: () => ({
              title: i18n.t('expenses_v2.breadcrumbs.my_cards'),
              illustration: 'credit-card',
            }),
          },
          element: <MyCardsPage />,
        },
        {
          path: navigation.myCards.cardId.path,
          loader: ({ params }) =>
            redirect(navigation.myCards.fullPath() + '?showCard=' + params.cardId),
        },
        {
          path: navigation.myCards.requestCard.path,
          element: <RequestCardPage />,
          handle: {
            meta: () => ({
              title: i18n.t('expenses_v2.buttons.request_single_use_card'),
            }),
          },
        },
      ],
    }),
  ]
}
